import { z } from "zod";

// 161 -- "tour" is an independent, non-league team kind (flexible A/B mix,
// exempt from the 147 same-event lock and league standings).
export const teamTypeEnum = z.enum(["main", "trial", "tour"]);
export const teamPlayerRoleEnum = z.enum(["player", "captain", "vice_captain"]);

// Team names are not user-editable -- they are computed from age group + rank
// (074). The server ignores any `name` in the request body.
export const createTeamSchema = z.object({
  age_group: z.string().default("Open").optional(), // Legacy string, prefer age_group_id
  age_group_id: z.string().nullable().optional(),
  sport_id: z.string().optional(),
  team_type: teamTypeEnum.default("main").optional(),
  is_default: z.boolean().default(false).optional(),
  season_year: z.number().int().nullable().optional(),
  // 157 -- house doctor / medical practice
  house_doctor_name: z.string().max(255).nullable().optional(),
  house_doctor_practice: z.string().max(255).nullable().optional(),
  house_doctor_phone: z.string().max(64).nullable().optional(),
});

export const updateTeamSchema = z.object({
  age_group: z.string().optional(), // Legacy string
  age_group_id: z.string().nullable().optional(),
  sport_id: z.string().nullable().optional(),
  team_type: teamTypeEnum.optional(),
  is_default: z.boolean().optional(),
  season_year: z.number().int().nullable().optional(),
  // 157 -- house doctor / medical practice
  house_doctor_name: z.string().max(255).nullable().optional(),
  house_doctor_practice: z.string().max(255).nullable().optional(),
  house_doctor_phone: z.string().max(64).nullable().optional(),
});

export const addPlayerToTeamSchema = z.object({
  player_id: z.string().min(1, "Player ID is required"),
  role: teamPlayerRoleEnum.default("player").optional(),
});

export const bulkAssignPlayersSchema = z.object({
  player_ids: z.array(z.string().min(1)).min(1, "At least one player required"),
  role: teamPlayerRoleEnum.default("player").optional(),
});

export const updatePlayerRoleSchema = z.object({
  role: teamPlayerRoleEnum,
});

export type CreateTeamInput = z.infer<typeof createTeamSchema>;
export type UpdateTeamInput = z.infer<typeof updateTeamSchema>;
export type AddPlayerToTeamInput = z.infer<typeof addPlayerToTeamSchema>;
export type BulkAssignPlayersInput = z.infer<typeof bulkAssignPlayersSchema>;
export type UpdatePlayerRoleInput = z.infer<typeof updatePlayerRoleSchema>;
